import {Component, Input} from '@angular/core';

@Component({
	selector: 'amd-card',
	templateUrl: './card.component.html',
	styleUrls: ['./card.component.scss']
})
export class CardComponent {
	@Input() title: string;
	@Input() icon: string;

	@Input() margin?: number;
	@Input() withoutMargin?: boolean;
}
